import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import PlayVideoButton from '../components/PlayVideoButton';
import Popup from '../components/Popup';

// Solution logos
import logoBook from '../assets/solutions/AgilysysBook.svg';
import logoMarketing from '../assets/solutions/AgilysysDigitalMarketing.svg';
import logoEatec from '../assets/solutions/AgilysysEatec.svg';
import logoExpressKiosk from '../assets/solutions/AgilysysExpressKiosk.svg';
import logoExpressMobile from '../assets/solutions/AgilysysExpressMobile.svg';
import logoGolf from '../assets/solutions/AgilysysGolf.svg';
import logoGuest from '../assets/solutions/AgilysysGuest.svg';
import logoDigitalMenu from '../assets/solutions/AgilysysIGDigitalMenu.svg';
import logoIGFly from '../assets/solutions/AgilysysIGFly.svg';
import logoIGKDS from '../assets/solutions/AgilysysIGKDS.svg';
import logoIGKiosk from '../assets/solutions/AgilysysIGKiosk.svg';
import logoIGOnDemand from '../assets/solutions/AgilysysIGOnDemand.svg';
import logoIGQuickPay from '../assets/solutions/AgilysysIGQuickPay.svg';
import logoIGSmartMenu from '../assets/solutions/AgilysysIGSmartMenu.svg';
import logoInfoGenesis from '../assets/solutions/AgilysysInfoGenesis.svg';
import logoLoyalty from '../assets/solutions/AgilysysLoyalty.svg';
import logoMembership from '../assets/solutions/AgilysysMembership.svg';
import logoPMS from '../assets/solutions/AgilysysPMS.svg';
import logoReserve from '../assets/solutions/AgilysysReserve.svg';
import logoRetail from '../assets/solutions/AgilysysRetail.svg';
import logoSales from '../assets/solutions/AgilysysSalesCatering.svg';
import logoService from '../assets/solutions/AgilysysService.svg';
import logoSpa from '../assets/solutions/AgilysysSpa.svg';
import logoBook4Time from '../assets/solutions/Book4Time.svg';

// Solution images
import imgBook3 from '../assets/solutions/book3.png';
import imgBook2 from '../assets/solutions/book2.png';
import imgMarketing1 from '../assets/solutions/marketing1.png';
import imgMarketing2 from '../assets/solutions/marketing2.png';
import imgEatec1 from '../assets/solutions/eatec1.png';
import imgEatec2 from '../assets/solutions/eatec2.png';
import imgGolfSol from '../assets/solutions/golf.png';
import imgIGFly1 from '../assets/solutions/IGFly1.png';
import imgIGKitchen1 from '../assets/solutions/IGKitchen1.png';
import imgIGQuickPay from '../assets/solutions/IGQuickPay.png';
import imgIGSmartMenu1 from '../assets/solutions/IGSmartMenu1.png';
import imgInfoGenesis1 from '../assets/solutions/InfoGenesis1.png';
import imgInfoGenesis2 from '../assets/solutions/Infogenesis2.png';
import imgReserve1 from '../assets/solutions/Reserve1.png';
import imgReserve3 from '../assets/solutions/Reserve3.png';
import imgBook4time1 from '../assets/solutions/book4time1.png';
import imgBook4time2 from '../assets/solutions/book4time2.png';
import imgIGOnDemand1 from '../assets/solutions/IGOnDemand1.png';
import imgIGOnDemand2 from '../assets/solutions/IGOnDemand2.png';
import imgIGKiosk1 from '../assets/solutions/IGKiosk1.png';
import imgIGKiosk2 from '../assets/solutions/IGKiosk2.png';
import imgLoyalty1 from '../assets/solutions/Loyalty1.png';
import imgLoyalty2 from '../assets/solutions/Loyalty2.png';
import imgMembership1 from '../assets/solutions/Membership1.png';
import imgMembership2 from '../assets/solutions/Membership2.png';
import imgPMS1 from '../assets/solutions/PMS1.png';
import imgRetail1 from '../assets/solutions/Retail1.png';
import imgCatering1 from '../assets/solutions/Catering1.png';
import imgService1 from '../assets/solutions/Service1.png';
import imgService2 from '../assets/solutions/Service2.png';
import imgService3 from '../assets/solutions/Service3.png';
import imgSpa1 from '../assets/solutions/Spa1.png';
import imgExpress1 from '../assets/solutions/express1.png';
import imgExpressMobile1 from '../assets/solutions/expressMobile1.png';
import imgGuestApp1 from '../assets/solutions/guestApp1.png';
import imgGuestApp2 from '../assets/solutions/guestApp2.png';
import imgDigitalMenu1 from '../assets/solutions/digitalMenu1.png';

// Solution videos
import vidBook from '../assets/videos/InteractiveBook2.mp4';
import vidMarketing from '../assets/videos/InteractiveMarketing.mp4';
import vidEatec from '../assets/videos/InteractiveEatec.mp4';
import vidExpressKiosk from '../assets/videos/InteractiveExpressKiosk.mp4';
import vidExpressMobile from '../assets/videos/InteractiveExpressMobile.mp4';
import vidGolf from '../assets/videos/InteractiveGolf.mp4';
import vidGuestApp from '../assets/videos/InteractiveGuestApp2.mp4';
import vidIGFly from '../assets/videos/InteractiveIGFly2.mp4';
import vidIGKDS from '../assets/videos/InteractiveIGKDS.mp4';
import vidIGKiosk from '../assets/videos/InteractiveIGKiosk.mp4';
import vidIGOnDemand from '../assets/videos/InteractiveIGOnDemand.mp4';
import vidIGQuickPay from '../assets/videos/InteractiveIGQuickPay.mp4';
import vidInfoGenesis from '../assets/videos/InteractiveInfoGenesis.mp4';
import vidLoyalty from '../assets/videos/InteractiveLoyalty.mp4';
import vidMembership from '../assets/videos/InteractiveMembership.mp4';
import vidPMS from '../assets/videos/InteractivePMS2.mp4';
import vidReserve from '../assets/videos/InteractiveReserve.mp4';
import vidRetail from '../assets/videos/InteractiveRetail.mp4';
import vidSales from '../assets/videos/InteractiveSalesCatering.mp4';
import vidService from '../assets/videos/InteractiveServiceStaff.mp4';
import vidSpa from '../assets/videos/InteractiveSpa.mp4';
import vidBook4Time from '../assets/videos/Book4TimeAnimatedVideo.mp4';

const solutionData = {
  'book': {
    title: 'Book',
    logo: logoBook,
    description: 'An easy-to-use reservation system that is designed to move residents effortlessly through the booking process for spa appointments, rounds of golf, and more.\n\nThe flexible, configurable solution displays real-time availability and the ability to offer service enhancements. The result is increased revenue at lower booking cost.',
    images: [imgBook3, imgBook2],
    video: vidBook,
    className: 'bookPage'
  },
  'marketing': {
    title: 'Digital Marketing',
    logo: logoMarketing,
    description: 'A flexible hospitality marketing automation solution supporting targeted guest email and SMS marketing communications with event and campaign-based rules.\n\nMarketers can segment guests by type or other criteria and send context-related communications at time of reservation, check-in, check-out or by marketing campaign types. Digital email campaigns allow users an inexpensive way to stay connected to their guest throughout the guest journey.\n\nThe result is increased return visits and improved revenue from offers based upon guest segment and journey stage.',
    images: [imgMarketing1, imgMarketing2],
    video: vidMarketing,
    className: 'marketingPage'
  },
  'eatec': {
    title: 'Eatec',
    logo: logoEatec,
    description: 'A modern, advanced inventory & procurement solution to help control the quality and consistency of your product purchases and inventory levels to ensure you have all of the ingredients for food & retail management success.\n\nThe solution helps to maximize every dollar by supporting in-house production and cycle menu management with plate cost analysis and integrated procurement, reducing waste, spoilage, theft and overstock.\n\nWith robust recipe and nutritional information management and a built-in banquet catering module, Eatec inventory & procurement management is a single flexible solution for multi-location food and item controls.\n\nThe result is lower food costs, fewer out of stock occurrences and streamlined inventory processes.',
    images: [imgEatec1, imgEatec2],
    video: vidEatec,
    className: 'eatecPage'
  },
  'express-kiosk': {
    title: 'Express Kiosk',
    logo: logoExpressKiosk,
    description: 'Eliminate front desk queues and help make travel more enjoyable by offering a fast and easy approach to efficient guest service.\n\nUse Express Kiosk to give your guests the self-service options they are looking for. Check-in, obtain card present EMV authorization, offer upgrades and alternative room options before dispensing the guest a key. Deploy the kiosk in high traffic areas such as elevator banks or parking areas and let guests quickly view their hotel folio, check-out and receive an electronic copy instantly.\n\nIncrease revenue, reduce overhead, and provide guests with the experience they are looking for with Express Kiosk.',
    images: [imgExpress1],
    video: vidExpressKiosk,
    className: 'expressKioskFPage'
  },
  'express-mobile': {
    title: 'Express Mobile',
    logo: logoExpressMobile,
    description: 'A complete mobile check-in and check-out guest experience with support for:\n\n\u2022 Digital Keys\n\u2022 ID Verification\n\u2022 Key Encoding\n\u2022 Room Ready Messaging\n\nWith Express, guests can avoid long front desk lines and enjoy a complete contactless process getting to their rooms and the property\u2019s amenities faster. The result is reduced lines at the front desk, greater staff productivity, and reduced operating costs.',
    images: [imgExpressMobile1],
    video: vidExpressMobile,
    className: 'expressMobileFPage'
  },
  'golf': {
    title: 'Golf',
    logo: logoGolf,
    description: 'A modern cloud-native pro shop & course management solution for Life Plan Community courses.\n\nWhether you\u2019re organizing tournaments, scheduling and tracking tee times, managing the pro shop, directing staff or overseeing player experiences, Agilysys Golf provides reliable property and golf management efficiency.\n\nSince it integrates seamlessly with PMS solutions, it\u2019s easy to share data across the enterprise; accessing player data including personal preferences, play histories and handicaps.',
    images: [imgGolfSol],
    video: vidGolf,
    className: 'golfFPage'
  },
  'guest-app': {
    title: 'Guest App',
    logo: logoGuest,
    description: 'Wrap your brand around a downloadable app that provides a frictionless guest experience from booking to check-out. Available in both the Android and iOS app stores, the Agilysys Guest App helps you showcase your property and drive revenue.\n\nThis simple mobile app allows guests to book rooms, golf and spa; check-in; use digital room keys; and check-out all from an app with your brand and property data.',
    images: [imgGuestApp1, imgGuestApp2],
    video: vidGuestApp,
    className: 'guestAppFPage'
  },
  'digital-menu': {
    title: 'IG Digital Menu Board',
    logo: logoDigitalMenu,
    description: 'IG Digital Menu Board provides a cloud-native large-format digital display on industry standard technology to present high quality images and menus for a variety of venues.\n\nIt allows users to create and design layouts using pre-defined templates, and schedule menus with auto-update at defined times for a specified menu list. It also supports rotating menus with promo prices for items and combos.',
    images: [imgDigitalMenu1],
    video: null,
    className: 'digitalMenuFPage'
  },
  'ig-fly': {
    title: 'IG Fly',
    logo: logoIGFly,
    description: 'Wherever your residents are, that\u2019s where your servers and your POS need to be. No more running from table to terminal and back. IG Fly empowers your staff to do it all on one device: table-side, pool-side, popup-side, wherever-side. Keep residents happy and servers hustling.\n\nBoost guest spending with sleek handheld devices that facilitate order placement and payment acceptance. Servers are readily available to satisfy residents\u2019 immediate requests while providing faster service.',
    images: [imgIGFly1],
    video: vidIGFly,
    className: 'IGFlyFPage'
  },
  'ig-kds': {
    title: 'IG KDS',
    logo: logoIGKDS,
    description: 'An integrated kitchen display system to manage kitchen orders. The Expo Display shows all orders for the kitchen, allowing an expediter to control the flow of orders and preparation times, while an Order Status Display shows residents the status of their orders which can be shown in an ADA format.\n\nFor IG OnDemand customers, KDS can also be deployed in the cloud with support for multiple KDS stations, routing, scheduled orders, a queue tab and sending an SMS message when orders are bumped. The result is a seamless order flow from order taking to kitchen management and resident notification.',
    images: [imgIGKitchen1],
    video: vidIGKDS,
    className: 'IGKDSFPage'
  },
  'ig-kiosk': {
    title: 'IG Kiosk',
    logo: logoIGKiosk,
    description: 'A self-service F&B ordering kiosk that integrates with InfoGenesis POS to serve residents 24-7. Residents casually select menu items, process their credit card payment and print a receipt - all using a simple interface. No service staff required, reducing the time it takes to serve each resident.\n\nFor those who want to make their own choices, on their own time, IG Kiosk offers the freedom to browse menu options whenever it\u2019s most convenient. Perfect for Grab N Go, cafeterias and fast service restaurants.\n\nThe result is improved service, increased efficiency and reduced operating costs.',
    images: [imgIGKiosk1, imgIGKiosk2],
    video: vidIGKiosk,
    className: 'IGKioskFPage'
  },
  'ig-on-demand': {
    title: 'IG OnDemand',
    logo: logoIGOnDemand,
    description: 'A complete cloud-native contactless self-service F&B ordering solution that offers an intuitive resident-facing order and pay experience. IG OnDemand allows residents to place and pay for orders using their own device - phone, tablet, laptop - for pick-up or delivery orders, as well as for a tableside order and pay experience.\n\nIt supports ordering for multiple residents at a table over the course of a meal using their own devices making the ordering process touchless while freeing up staff to spend more time with residents. The result is dramatically increased revenue opportunities and more chances to enhance service.',
    images: [imgIGOnDemand1, imgIGOnDemand2],
    video: vidIGOnDemand,
    className: 'IGOnDemandFPage'
  },
  'ig-quick-pay': {
    title: 'IG Quick Pay',
    logo: logoIGQuickPay,
    description: 'A cloud-native touchless payment experience allowing residents to use their own mobile device to scan a QR code on the InfoGenesis check linking to a digital copy of the check where they can review it, add a tip & initiate payment.\n\nThe result is a streamlined, fully contactless payment process that protects the health of residents and staff alike, while helping to speed table turnover.',
    images: [imgIGQuickPay],
    video: vidIGQuickPay,
    className: 'IGQuickPayFPage'
  },
  'ig-smart-menu': {
    title: 'IG Smart Menu',
    logo: logoIGSmartMenu,
    description: 'A cloud-native contactless menu display on a residents\u2019 own mobile device - phone, tablet, or laptop. Residents simply scan a QR code to access a venue menu that is linked directly to the actual items available in the OnDemand system, rather than a PDF or a website link.\n\nThe result is a fully contactless menu display experience that protects the health of residents and staff alike, while helping to reduce menu printing and update costs.',
    images: [imgIGSmartMenu1],
    video: null,
    className: 'IGSmartMenuFPage'
  },
  'info-genesis': {
    title: 'InfoGenesis',
    logo: logoInfoGenesis,
    description: 'An award-winning enterprise-class point-of-sale solution that processes transactions in the highest volume, most demanding environments.\n\nA comprehensive POS system, it combines highly interactive terminal and tablet touchscreen applications supporting Windows, Android and iOS devices. Its robust reporting and analysis features, extensive enterprise-grade menu and item configuration capabilities, and multi-language support, help to drive service flexibility and increased operational efficiency.\n\nThe result is improved F&B operations and increased revenue across venues.',
    images: [imgInfoGenesis1, imgInfoGenesis2],
    video: vidInfoGenesis,
    className: 'infoGenesisFPage'
  },
  'loyalty': {
    title: 'Loyalty & Promotions',
    logo: logoLoyalty,
    description: 'A comprehensive loyalty and promotions management solution to help operators track guest preferences and craft a wide variety of programs and offers. Loyalty & Promotions supports point earning and redemption at every guest interaction and provides a guest portal for self-service account management.\n\nThe result is increased guest wallet-share through repeat visits by leveraging guest preferences for targeted promotions and offers.',
    images: [imgLoyalty1, imgLoyalty2],
    video: vidLoyalty,
    className: 'loyaltyFPage'
  },
  'memberships': {
    title: 'Membership',
    logo: logoMembership,
    description: 'Control your programs by defining the membership types you need. Whether you manage memberships for individuals, families, groups, corporate accounts or all of these, you define the parameters for each.\n\nThe Membership Portal allows easy online registrations for new members and gives members the ability to check their balances and redeem points via gift cards, eCash, loyalty, etc.',
    images: [imgMembership1, imgMembership2],
    video: vidMembership,
    className: 'membershipsFPage'
  },
  'pms': {
    title: 'PMS',
    logo: logoPMS,
    description: 'Agilysys delivers the industry\u2019s most modern, robust and innovative PMS solutions aligned with property preferences to preserve the power to choose. From an individual location to an enterprise chain, get the most modern, comprehensive property management solutions for managing your hospitality business.',
    images: [imgPMS1],
    video: vidPMS,
    className: 'PMSFPage'
  },
  'reserve': {
    title: 'Reserve',
    logo: logoReserve,
    description: 'Activities \u2014 A modern cloud-native activity booking and management solution for Life Plan Communities offering a variety of activities. From golf lessons and art sessions to theater productions and more, it offers a flexible, configurable solution that will integrate with POS solutions for resident preferences as well as become part of a common resident itinerary.\n\nDining \u2014 A complete online table reservation, wait-list and venue management system that is designed to display and manage seat availability for a wide range of venues including restaurants, poolside cabanas, special events and more.',
    images: [imgReserve1, imgReserve3],
    video: vidReserve,
    className: 'reserveFPage'
  },
  'retail': {
    title: 'Retail',
    logo: logoRetail,
    description: 'Our POS solution supports retail item sales for spas, pro shops, gift shops, and more that don\u2019t require a full enterprise POS system. Easily set up and track inventory, or sell items to residents as part of other services.',
    images: [imgRetail1],
    video: vidRetail,
    className: 'retailFPage'
  },
  'sales': {
    title: 'Sales & Catering',
    logo: logoSales,
    description: 'A cloud-native comprehensive sales & event management system that provides powerful tools for hotels, conference centers and resorts of all sizes. With a complete view of every group and event, as well as guests throughout their entire stay, the system fully exposes the value of each guest and group across meeting and shoulder dates.\n\nThe result is improved event revenue opportunities and streamlined management enabling event planners and sales teams to more efficiently sell, manage and service their clients.',
    images: [imgCatering1],
    video: vidSales,
    className: 'salesFPage'
  },
  'service': {
    title: 'Service',
    logo: logoService,
    description: 'Service on time, every time, without over-stressing staff. Real-time texts between guests and service staff simplifies timing, tracking and satisfying requests. Assign and route service requests to a mobile-equipped team to save time and balance workloads. Minimize training time and protect brand standards through guided task instructions.\n\nThe solution offers an enhanced guest experience through 2-way SMS communications with staff, as well as support for guided hotel room cleaning and inspections, and preventive maintenance.',
    images: [imgService1, imgService2, imgService3],
    video: vidService,
    className: 'serviceFPage'
  },
  'spa': {
    title: 'Spa',
    logo: logoSpa,
    description: 'A modern spa management, cloud-native, mobile software solution delivers an effortless check-in and staff scheduling process, while intuitive drag and drop appointment management helps maximize therapist and treatment room utilization. Simple POS integration, makes it easy to manage and share data across the community.\n\nAnd our guestsense.ai-enabled solution helps optimize revenue and provides a conversational AI Concierge to fully automate the entire reservation flow in a natural conversation.\n\nThe result is increased revenue through yield management insights and an exclusive spa experience for each and every resident.',
    images: [imgSpa1],
    video: vidSpa,
    className: 'spaFPage'
  },
  'book4time': {
    title: 'Book4Time',
    logo: logoBook4Time,
    description: 'Drive Spa revenue while delivering a 5-Star resident experience with a solution built to make life easier and integrate with your existing Agilysys systems. Book appointments, set-up loyalty rewards and manage inventory across multiple locations.',
    images: [imgBook4time1, imgBook4time2],
    video: vidBook4Time,
    className: 'book4timePage'
  }
};

const SolutionPage = () => {
  const { slug } = useParams();
  const [showVideo, setShowVideo] = useState(false);
  const solution = solutionData[slug];

  if (!solution) {
    return (
      <div className="page splash">
        <Header />
        <div style={{ color: '#fff', textAlign: 'center', paddingTop: '40vh', fontSize: '24px' }}>
          Solution not found
        </div>
      </div>
    );
  }

  return (
    <div className={`page splash ${solution.className}`}>
      <Header />

      <div className="page-title">
        <img src={solution.logo} alt={solution.title} />
      </div>

      <div className="text-blocks">
        <div className="std-text">{solution.description}</div>
      </div>

      {solution.video && (
        <PlayVideoButton onClick={() => setShowVideo(true)} />
      )}

      {solution.images && solution.images.map((img, i) => (
        <img
          key={i}
          className={`img-${i + 1}`}
          src={img}
          alt={solution.title}
        />
      ))}

      <Popup showPopup={showVideo} setShowPopup={() => setShowVideo(false)} disableOffClick>
        {showVideo && (
          <video autoPlay controls src={solution.video} />
        )}
      </Popup>
    </div>
  );
};

export default SolutionPage;
